module.exports = __webpack_public_path__ + "static/media/F1.f1c81b59.mp3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/piano/F1.mp3
// module id = 121
// module chunks = 0